var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUploadIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "#5B7E95",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.16 11.2975C20.3137 10.8962 20.4 10.4575 20.4 10C20.4 8.0125 18.7875 6.4 16.8 6.4C16.0613 6.4 15.3713 6.625 14.8013 7.0075C13.7625 5.2075 11.8238 4 9.6 4C6.285 4 3.6 6.685 3.6 10C3.6 10.1012 3.60375 10.2025 3.6075 10.3037C1.5075 11.0425 0 13.045 0 15.4C0 18.3812 2.41875 20.8 5.4 20.8H19.2C21.8513 20.8 24 18.6512 24 16C24 13.6787 22.35 11.74 20.16 11.2975ZM14.7525 13.6H12.3V17.8C12.3 18.13 12.03 18.4 11.7 18.4H9.9C9.57 18.4 9.3 18.13 9.3 17.8V13.6H6.8475C6.31125 13.6 6.045 12.955 6.42375 12.5762L10.3763 8.62375C10.6088 8.39125 10.9912 8.39125 11.2237 8.62375L15.1763 12.5762C15.555 12.955 15.285 13.6 14.7525 13.6V13.6Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadIcon);
export default __webpack_public_path__ + "static/media/upload-icon.36fbc24b.svg";
export { ForwardRef as ReactComponent };